// This icon file is generated automatically.
var PFileCopyOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M12 0H3.62a.13.13 0 00-.12.13V1c0 .07.06.13.13.13h7.75v10.75c0 .06.05.12.12.12h.88c.06 0 .12-.06.12-.13V.5A.5.5 0 0012 0zm-2 2H2a.5.5 0 00-.5.5v8.3c0 .13.05.25.15.35l2.7 2.7.12.09v.03h.07a.5.5 0 00.17.03H10a.5.5 0 00.5-.5v-11A.5.5 0 0010 2zM4.47 12.38l-1.35-1.35h1.35v1.35zm4.9.5h-3.9v-2.22a.62.62 0 00-.63-.63H2.63v-6.9h6.75v9.75z", "fill-rule": "nonzero" } }] }, "name": "p-file-copy", "theme": "outlined" };
export default PFileCopyOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PFileCopyOutlined.js
// module id = 3378
// module chunks = 0